module.exports = __webpack_public_path__ + "media/invest.523b4db.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/invest.mp4
// module id = 3qTo
// module chunks = 3